<template>
  <v-tooltip top color="grey400">
    <template #activator="{on}">
      <span
        class="user-level d-inline-block"
        :class="$vnode.data.staticClass"
        v-on="on"
      >
        <v-img
          width="1.1em"
          :aspect-ratio="1"
          :src="require(`@/assets/img/levels/tiers/${tier}.png`)"
        />
      </span>
    </template>
    <span v-text="$tc('common.level', level)" />
  </v-tooltip>
</template>

<script>
const LEVELS_PER_TIER = 10
const MAX_TIER = 20

export default {
  props: {
    level: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    tier() {
      const tier = Math.min(Math.floor(this.level / LEVELS_PER_TIER), MAX_TIER)
      return tier
    },
  },
}
</script>

<style lang="scss" scoped>
.v-image {
  display: inline-flex;
  font-size: 1.4em;
  vertical-align: middle;
  flex: 1 0 0;
}

::v-deep .user-flair-tooltip {
  background: red;
}
</style>
